// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewItem_root__tgMvc"};